module.exports = {
      id: "share-linkedin-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#share-linkedin",
      toString: function () {
        return this.url;
      }
    }